import { useEffect, useMemo, useRef, useState } from 'react';
import ffinUploadCarPhoto from '../../../../api/bank/ffinUploadCarPhoto';
import alert from '../../../../helpers/alert';
import { BANKS } from '../../../../constants';
import { SLOTS, slotsFor } from './carPhotoSlots';

// Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð·Ð°Ð»Ð¾Ð³Ð° (ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ / Ð±/Ñ Ð°Ð²ÑÐ¾). ÐÑÐ¶Ð½Ñ Ð¸ Freedom, Ð¸
// Jet Finance: Ð·Ð°Ð³ÑÑÐ¶Ð°ÑÑÑÑ Ð² Ð¾Ð´Ð½Ð¾ Ð¼ÐµÑÑÐ¾, Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ ÑÐ´ÐµÐ»ÐºÐ¸, Ð° Ð´Ð°Ð»ÑÑÐµ ÐºÐ°Ð¶Ð´ÑÐ¹ Ð±Ð°Ð½Ðº
// Ð·Ð°Ð±Ð¸ÑÐ°ÐµÑ Ð¸Ñ Ð¿Ð¾-ÑÐ²Ð¾ÐµÐ¼Ñ â Freedom Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Ð±Ð°Ð½ÐºÐ° (Ð´Ð¾ /confirm), Jet Finance
// Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ ÑÐºÐ¾ÑÐ¸Ð½Ð³Ð°.
// ÐÐ°ÐºÐ¸Ðµ ÑÐ°ÐºÑÑÑÑ ÐºÐ¾Ð¼Ñ Ð½ÑÐ¶Ð½Ñ â Ð² carPhotoSlots.js.
const CommissionPhotos = ({ appealId, documents, onReadyChange, banks = [], newCar = false }) => {
  const slots = useMemo(() => slotsFor(banks, { newCar }), [banks, newCar]);
  const forJetFin = banks.includes(BANKS.JETFIN);
  // ÐÐ°ÐºÐ¸Ðµ ÑÐ°ÐºÑÑÑÑ ÑÐ¶Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ (Ð¿Ð¾ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°Ð¼ ÑÐ´ÐµÐ»ÐºÐ¸) â ÑÑÐ¾Ð±Ñ Ð½Ðµ ÑÐµÑÑÑÑ Ð¿ÑÐ¸ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐµ.
  const initialDone = useMemo(() => {
    const done = {};
    (documents || []).forEach((d) => {
      SLOTS.forEach((s) => {
        if (d?.typeId === s.typeId && (d?.serialNumberId ?? 1) === s.serial) {
          done[s.key] = true;
        }
      });
    });
    return done;
  }, [documents]);

  const [done, setDone] = useState(initialDone);
  const [busy, setBusy] = useState(null);
  const inputs = useRef({});

  // ÐÐ¼ÐµÐ½Ð½Ð¾ Ð¿Ð¾ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð½ÑÐ¼: ÑÑÐµÐ±Ð¾Ð²Ð°ÑÑ ÑÐ°ÐºÑÑÑ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ð½ÐµÑ, Ð·Ð½Ð°ÑÐ¸Ñ
  // Ð·Ð°Ð¿ÐµÑÐµÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð² Ð±Ð»Ð¾ÐºÐµ Ð±ÐµÐ· Ð²Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÐ¸ ÐµÐ³Ð¾ Ð·Ð°ÐºÑÑÑÑ.
  const requiredKeys = slots.filter((s) => s.required).map((s) => s.key);
  const ready = requiredKeys.every((k) => done[k]);

  useEffect(() => {
    onReadyChange && onReadyChange(ready);
  }, [ready, onReadyChange]);

  const pick = (slot) => inputs.current[slot.key]?.click();

  const onFile = async (slot, e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!appealId) {
      alert.error('ÐÐ°ÑÐ²ÐºÐ° Freedom ÐµÑÑ Ð½Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð° â ÑÐ¾ÑÐ¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð½ÐµÐ»ÑÐ·Ñ');
      return;
    }
    setBusy(slot.key);
    try {
      await ffinUploadCarPhoto({ appealId, documentType: slot.key, file });
      setDone((prev) => ({ ...prev, [slot.key]: true }));
      alert.success(`Ð¤Ð¾ÑÐ¾ Â«${slot.label}Â» Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾`);
    } catch (err) {
      alert.error(err?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¾ÑÐ¾');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: 12,
        padding: 16,
        marginBottom: 20,
        background: ready ? '#f2fbf3' : '#fff8f0',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>
        {newCar ? 'Ð¤Ð¾ÑÐ¾ VIN Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ°' : 'Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð·Ð°Ð»Ð¾Ð³Ð°'}
      </div>
      <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
        {newCar ? (
          'ÐÐ¾Ð²Ð¾Ðµ Ð°Ð²ÑÐ¾ Ð¸Ð· ÑÐ°Ð»Ð¾Ð½Ð°. Jet Finance Ð¶Ð´ÑÑ Ð´Ð²Ð° ÑÐ½Ð¸Ð¼ÐºÐ° VIN: Ð²ÑÐ±Ð¸ÑÑÐ¹ Ð½Ð° ÐºÑÐ·Ð¾Ð²Ðµ Ð¸ Ð½Ð°ÐºÐ»ÐµÐ¹ÐºÑ â Ð¸Ñ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ðµ Ð´Ð²Ð°. ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ Ð¿Ð¾ÑÐ»Ðµ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ, Ð² Ð±Ð°Ð½Ðº Ð¾Ð½Ð¸ ÑÐ¹Ð´ÑÑ ÑÐ°Ð¼Ð¸.'
        ) : (
          <>
            ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ / Ð±/Ñ Ð°Ð²ÑÐ¾. ÐÑÑÑ ÑÐ¾ÑÐ¾ ÑÐ¾ Ð·Ð²ÑÐ·Ð´Ð¾ÑÐºÐ¾Ð¹ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ñ: Ð±ÐµÐ· Ð½Ð¸Ñ Freedom Ð¾ÑÐºÐ»Ð¾Ð½Ð¸Ñ Ð·Ð°ÑÐ²ÐºÑ, Ð¸ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ
            Ð¸Ñ Ð½ÑÐ¶Ð½Ð¾ Ð´Ð¾ Ð²ÑÐ±Ð¾ÑÐ° Ð±Ð°Ð½ÐºÐ°.
            {forJetFin ? ' ÐÑÑÐ°Ð»ÑÐ½ÑÐµ ÑÐ°ÐºÑÑÑÑ Ð¸Ð´ÑÑ Ð² Ð¾ÑÐµÐ½ÐºÑ Ð·Ð°Ð»Ð¾Ð³Ð° Jet Finance â ÑÐµÐ¼ Ð±Ð¾Ð»ÑÑÐµ, ÑÐµÐ¼ ÑÐ¾ÑÐ½ÐµÐµ.' : ''}
          </>
        )}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        {slots.map((slot) => (
          <div
            key={slot.key}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              minWidth: 150,
            }}
          >
            <button
              type="button"
              onClick={() => pick(slot)}
              disabled={busy === slot.key}
              style={{
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: 8,
                border: '1px solid #c8c8c8',
                background: done[slot.key] ? '#e3f5e6' : '#fff',
                width: '100%',
                textAlign: 'left',
              }}
            >
              {done[slot.key] ? 'â ' : ''}
              {slot.label}
              {slot.required ? ' *' : ''}
              {busy === slot.key ? ' â¦' : ''}
            </button>
            {slot.hint ? (
              <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{slot.hint}</div>
            ) : null}
            <input
              ref={(el) => (inputs.current[slot.key] = el)}
              type="file"
              accept="image/png,image/jpeg"
              style={{ display: 'none' }}
              onChange={(e) => onFile(slot, e)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommissionPhotos;
